var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92896 42.0406L47.8394 42.0406C47.8394 53.102 39.0547 62.073 28.2197 62.073L26.953 62.073L23.2619 62.0098C13.028 61.3303 4.92673 52.6618 4.92896 42.0406Z",
    fill: "#3388FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.0942e-06 25.0324L35.6911 60.7235C36.4448 61.4773 37.4682 61.899 38.5341 61.8951L59.0146 61.8206C61.218 61.8125 63 60.024 63 57.8206L63 42.5313C63 39.8791 61.9464 37.3356 60.0711 35.4602L24.6109 1.07577e-06",
    fill: "#003C8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92896 8.80348C4.92896 6.18323 7.05309 4.05908 9.67335 4.05908H22.5887C41.6583 4.05908 57.1173 19.5181 57.1173 38.5877C57.1173 40.4947 55.5714 42.0406 53.6644 42.0406H4.92896V8.80348Z",
    fill: "#1760CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4255 47.8394H46.6794C46.6794 50.0811 44.8621 51.8984 42.6203 51.8984H19.4255V47.8394Z",
    fill: "#47995A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8809 46.3896H45.6796C46.2318 46.3896 46.6796 46.8374 46.6796 47.3896V47.8393H40.8809V46.3896Z",
    fill: "#47995A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.464 10.4377C39.7548 10.4377 42.4224 13.1054 42.4224 16.3962L42.4224 43.4574C42.4224 48.8541 45.4112 50.6103 46.6794 47.8394C46.6794 50.1703 44.9398 51.8985 42.4224 51.8985H20.3266L19.8301 51.8985C19.9062 51.8985 19.9818 51.8964 20.057 51.8925C16.8914 51.7515 14.3682 49.1404 14.3682 45.94V10.4377H36.464Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6368 20.865H19.4578C19.115 20.865 18.8372 21.1429 18.8372 21.4857C18.8372 21.8284 19.115 22.1063 19.4578 22.1063H29.6368C29.9796 22.1063 30.2575 21.8284 30.2575 21.4857C30.2575 21.1429 29.9796 20.865 29.6368 20.865Z",
    fill: "#47995A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1056 23.3477H19.4578C19.115 23.3477 18.8372 23.6255 18.8372 23.9683C18.8372 24.3111 19.115 24.589 19.4578 24.589H34.1056C34.4484 24.589 34.7263 24.3111 34.7263 23.9683C34.7263 23.6255 34.4484 23.3477 34.1056 23.3477Z",
    fill: "#47995A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6299 30.2991H19.4578C19.115 30.2991 18.8372 30.577 18.8372 30.9197C18.8372 31.2625 19.115 31.5404 19.4578 31.5404H30.6299C30.9727 31.5404 31.2505 31.2625 31.2505 30.9197C31.2505 30.577 30.9727 30.2991 30.6299 30.2991Z",
    fill: "#47995A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6299 40H19.4578C19.115 40 18.8372 40.2779 18.8372 40.6207C18.8372 40.9635 19.115 41.2413 19.4578 41.2413H30.6299C30.9727 41.2413 31.2505 40.9635 31.2505 40.6207C31.2505 40.2779 30.9727 40 30.6299 40Z",
    fill: "#47995A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9197 32.7817H19.4578C19.115 32.7817 18.8372 33.0596 18.8372 33.4024C18.8372 33.7452 19.115 34.0231 19.4578 34.0231H24.9197C25.2625 34.0231 25.5404 33.7452 25.5404 33.4024C25.5404 33.0596 25.2625 32.7817 24.9197 32.7817Z",
    fill: "#47995A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9197 42.4827H19.4578C19.115 42.4827 18.8372 42.7605 18.8372 43.1033C18.8372 43.4461 19.115 43.724 19.4578 43.724H24.9197C25.2625 43.724 25.5404 43.4461 25.5404 43.1033C25.5404 42.7605 25.2625 42.4827 24.9197 42.4827Z",
    fill: "#47995A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8572 13.6672C32.7279 14.2042 32.2924 14.6583 31.7401 14.6583H11.1478C10.5955 14.6583 10.1356 14.2042 10.2648 13.6672C10.7106 11.8145 12.3787 10.4377 14.3683 10.4377H36.9607C34.9711 10.4377 33.303 11.8145 32.8572 13.6672Z",
    fill: "#47995A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUser);
export default __webpack_public_path__ + "static/media/edit_user.d32943c5.svg";
export { ForwardRef as ReactComponent };